
import { Context } from '@nuxt/types'
import { defineComponent } from 'vue'
import MachinationsLightPage from '~/domain/pages/MachinationsLightPage'
import { DiagramStoreActions } from '@interfaces/index'

export default defineComponent({
  name: 'glossary',
  extends: MachinationsLightPage,
  layout: 'machinations',
  head() {
    // @ts-ignore
    const pageHead = this.pageHead()
    return {
      ...pageHead,
      title: `Game Design Glossary`,
    }
  },
  async asyncData(context: Context): Promise<void> {
    const { store } = context

    await store.dispatch('wp/fetchPageBySlug', {
      context,
      slug: 'glossary',
    })

    await store.dispatch('common/setupPageLight', { context })

    const glossaryChapters = store.getters["wp/getAcfBlocks"][0].block.chapters[0];

    const extractedFuids = Object.values(glossaryChapters.chapter)
      .map((item: any) => item?.diagramFuid)
      .filter(fuid => fuid);

    await store.dispatch(DiagramStoreActions.GET_GLOSSARY_DIAGRAMS, {
      context,
      params: {
        fileKeys: extractedFuids,
        diagramView: "true",
      },
    })

    const chaptersWithSlugs = Object.values(glossaryChapters.chapter).map((chapter: any) => {
      const slug = chapter.title.trim().toLowerCase().replace(/ /g, '-').replace(/[^\w-]+/g, '');
      return {
        ...chapter,
        slug: slug
      };
    });
    //@ts-ignore
    return { chapters: chaptersWithSlugs };

  },
})
